{
  "familyId": "MET-MEETK-OPP",
  "questions": [
    {
      "id": "MET-MEETK-OPP-001",
      "familyId": "MET-MEETK-OPP",
      "module": "Metriek",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_opp_cirkel",
      "questionType": "multiple_choice",
      "question": "Een cirkel heeft een straal van 5 cm. Wat is de oppervlakte? (gebruik π ≈ 3,14)",
      "context": null,
      "options": ["78,5 cm²", "31,4 cm²", "15,7 cm²", "100 cm²"],
      "correctAnswer": 0,
      "stimulusAids": [{"type":"circle","data":{"radius":5,"highlightRadius":true,"label":"Cirkel met straal 5 cm"}}],
      "supportAids": [{"type":"rule","showWhen":"wrong","data":{"title":"Oppervlakte cirkel","content":"Oppervlakte = π × straal² = 3,14 × 5² = 3,14 × 25 = 78,5 cm². Let op: eerst kwadrateren!","icon":"lightbulb"}}],
      "conceptId": "circle_area_basic",
      "variantIndex": 1,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "De oppervlakteformule is: oppervlakte = π × straal². Eerst kwadrateren: 5² = 25. Dan met π: 3,14 × 25 = 78,5 cm². Snelle controle: π is iets meer dan 3, dus oppervlakte ≈ 3 × 25 = 75 — past bij 78,5. Onthoud: eenheid is cm² (vlak), niet cm (lengte).",
        "solutionSteps": [
          "Formule: oppervlakte = π × straal²",
          "Kwadrateer eerst: 5² = 5 × 5 = 25",
          "Vermenigvuldig met π: 3,14 × 25 = 78,5 cm²",
          "Check: ≈ 3 × 25 = 75 → klopt"
        ],
        "distractorExplanations": {
          "0": "Goed! π × straal² = 3,14 × 25 = 78,5 cm². De straal is correct gekwadrateerd voordat met π werd vermenigvuldigd.",
          "1": "Je hebt de omtrekformule gebruikt: 2 × π × 5 = 31,4 cm. Maar de vraag is naar de oppervlakte (cm²), niet de omtrek (cm). Onthoud: oppervlakte = πr² (mét kwadraat), omtrek = 2πr (zonder kwadraat).",
          "2": "Je bent het kwadrateren vergeten: π × 5 = 15,7. Maar de formule is π × straal², niet π × straal. Onthoud: zonder het kwadraat krijg je een halve omtrek, geen oppervlakte.",
          "3": "Je hebt alleen de straal gekwadrateerd zonder π: 5² × … = 100 (of vergelijkbaar). Maar π is essentieel: 3,14 × 25 = 78,5 cm². Onthoud: de π hoort er altijd bij."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.cirkel-opp-als-omtrek", "label": "Omtrekformule i.p.v. oppervlakte", "optionIndex": 1 },
          { "id": "met.cirkel-opp-zonder-kwadraat", "label": "Kwadraat vergeten", "optionIndex": 2 },
          { "id": "met.cirkel-opp-diameter-zonder-pi", "label": "π vergeten", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-MEETK-OPP-002",
      "familyId": "MET-MEETK-OPP",
      "module": "Metriek",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_opp_cirkel",
      "questionType": "multiple_choice",
      "question": "De diameter van een cirkel is 10 cm. Wat is de oppervlakte? (gebruik π ≈ 3,14)",
      "context": null,
      "options": ["31,4 cm²", "314 cm²", "78,5 cm²", "100 cm²"],
      "correctAnswer": 2,
      "stimulusAids": [{"type":"circle","data":{"diameter":10,"highlightDiameter":true,"label":"Cirkel met diameter 10 cm"}}],
      "supportAids": [{"type":"rule","showWhen":"wrong","data":{"title":"Eerst straal berekenen","content":"Straal = diameter ÷ 2 = 10 ÷ 2 = 5 cm. Daarna: oppervlakte = π × 5² = 78,5 cm².","icon":"lightbulb"}}],
      "conceptId": "circle_area_diameter",
      "variantIndex": 2,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "De oppervlakteformule werkt met de straal, niet met de diameter. Stap 1: straal = diameter ÷ 2 = 10 ÷ 2 = 5 cm. Stap 2: oppervlakte = π × straal² = 3,14 × 25 = 78,5 cm². Snelle check: π × 10² zou 314 cm² zijn — viermaal te groot, want diameter is 2× straal en gekwadrateerd dus 4×.",
        "solutionSteps": [
          "Bereken eerst de straal: 10 ÷ 2 = 5 cm",
          "Formule: oppervlakte = π × straal²",
          "Kwadrateer: 5² = 25",
          "Reken: 3,14 × 25 = 78,5 cm²"
        ],
        "distractorExplanations": {
          "0": "Je hebt de omtrek berekend (π × 10 = 31,4 cm). Maar de vraag is naar de oppervlakte (cm²). Onthoud: oppervlakte = πr², omtrek = πd.",
          "1": "Je hebt de diameter gekwadrateerd in plaats van eerst de straal te berekenen: 3,14 × 10² = 314. Maar de formule gebruikt de straal: eerst 10 ÷ 2 = 5, dan π × 5² = 78,5 cm².",
          "2": "Goed! Straal = 5 cm, oppervlakte = π × 25 = 78,5 cm².",
          "3": "Je hebt alleen de diameter gekwadrateerd zonder π: 10² = 100. Maar π is essentieel: 3,14 × 5² = 78,5 cm². Onthoud: én delen door 2 (straal), én kwadrateren, én × π."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.cirkel-opp-als-omtrek", "label": "Omtrekformule gebruikt", "optionIndex": 0 },
          { "id": "met.cirkel-opp-diameter-kwadraat", "label": "Diameter gekwadrateerd", "optionIndex": 1 },
          { "id": "met.cirkel-opp-diameter-zonder-pi", "label": "Diameter² zonder π", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-MEETK-OPP-003",
      "familyId": "MET-MEETK-OPP",
      "module": "Metriek",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_opp_cirkel",
      "questionType": "multiple_choice",
      "question": "Een cirkel heeft een oppervlakte van 314 cm². Wat is de straal? (gebruik π ≈ 3,14)",
      "context": null,
      "options": ["100 cm", "10 cm", "5 cm", "20 cm"],
      "correctAnswer": 1,
      "stimulusAids": [{"type":"circle","data":{"radius":10,"label":"Cirkel met opp 314 cm²"}}],
      "supportAids": [{"type":"rule","showWhen":"wrong","data":{"title":"Straal uit oppervlakte","content":"Oppervlakte = π × straal². Dus straal² = 314 ÷ 3,14 = 100, en straal = √100 = 10 cm.","icon":"lightbulb"}}],
      "conceptId": "circle_radius_from_area",
      "variantIndex": 3,
      "citoDifficulty": 0.54,
      "citoDiscrimination": 0.65,
      "feedback": {
        "explanationText": "Twee stappen om terug te rekenen: (1) deel door π → straal² = 314 ÷ 3,14 = 100. (2) Trek de wortel → straal = √100 = 10 cm. Controleer: π × 10² = 3,14 × 100 = 314 ✓. Onthoud: bij πr² ondoe je éérst de × π en dán het kwadraat (wortel).",
        "solutionSteps": [
          "Begin met: oppervlakte = π × straal²",
          "Draai om: straal² = oppervlakte ÷ π",
          "Vul in: 314 ÷ 3,14 = 100",
          "Trek wortel: straal = √100 = 10 cm",
          "Check: π × 10² = 314 ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt straal² = 100 berekend maar de wortel niet getrokken. Straal = √100 = 10 cm, niet 100. Onthoud: na ÷ π komt nog √.",
          "1": "Goed! Straal² = 100 → straal = √100 = 10 cm.",
          "2": "Je hebt waarschijnlijk door 2π gedeeld (314 ÷ 6,28 ≈ 50) of een andere fout gemaakt. De juiste aanpak: 314 ÷ 3,14 = 100, dan √100 = 10. Onthoud: deel door π (niet 2π).",
          "3": "Je hebt de diameter gegeven (2 × 10 = 20 cm), niet de straal. De formule levert de straal direct op: 10 cm."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.cirkel-opp-vergeet-wortel", "label": "Wortel vergeten", "optionIndex": 0 },
          { "id": "met.cirkel-opp-deel-2pi", "label": "÷ 2π i.p.v. ÷ π", "optionIndex": 2 },
          { "id": "met.cirkel-opp-diameter-ipv-straal", "label": "Diameter i.p.v. straal", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-MEETK-OPP-004",
      "familyId": "MET-MEETK-OPP",
      "module": "Metriek",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_opp_cirkel",
      "questionType": "multiple_choice",
      "question": "Een pizzabakker snijdt een pizza met een diameter van 30 cm doormidden. Wat is de oppervlakte van een halve pizza? (gebruik π ≈ 3,14)",
      "context": "Een pizzabakker snijdt pizza's voor klanten.",
      "options": ["706,5 cm²", "47,1 cm²", "225 cm²", "353,25 cm²"],
      "correctAnswer": 3,
      "stimulusAids": [{"type":"circle","data":{"radius":15,"highlightRadius":true,"label":"Pizza ∅ 30 cm"}}],
      "supportAids": [{"type":"rule","showWhen":"wrong","data":{"title":"Halve cirkel","content":"Stap 1: straal = 30 ÷ 2 = 15 cm. Stap 2: hele opp = π × 15² = 706,5 cm². Stap 3: halve opp = 706,5 ÷ 2 = 353,25 cm².","icon":"lightbulb"}}],
      "conceptId": "circle_area_half",
      "variantIndex": 4,
      "citoDifficulty": 0.56,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Drie stappen. (1) Straal: 30 ÷ 2 = 15 cm. (2) Hele oppervlakte: π × 15² = 3,14 × 225 = 706,5 cm². (3) Halveren: 706,5 ÷ 2 = 353,25 cm². Tip: lees de vraag goed — 'halve pizza' betekent dat je het eindantwoord nog door 2 deelt.",
        "solutionSteps": [
          "Straal = diameter ÷ 2 = 30 ÷ 2 = 15 cm",
          "Hele oppervlakte = π × 15² = 3,14 × 225 = 706,5 cm²",
          "Halveren: 706,5 ÷ 2 = 353,25 cm²",
          "Check: 353,25 × 2 = 706,5 ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt de hele pizza berekend (706,5 cm²) maar het halveren vergeten. De vraag is naar een halve pizza: 706,5 ÷ 2 = 353,25 cm². Onthoud: lees zorgvuldig wat er gevraagd wordt.",
          "1": "Je hebt de halve omtrek berekend (½ × π × 30 = 47,1 cm), niet de halve oppervlakte. Onthoud: oppervlakte = πr² (cm²), omtrek = πd (cm). De eenheid verraadt de fout.",
          "2": "Je hebt alleen 15² = 225 berekend zonder π en zonder halveren. De volledige berekening: 3,14 × 225 = 706,5, dan ÷ 2 = 353,25 cm².",
          "3": "Goed! Straal = 15 cm, hele opp = 706,5 cm², halve pizza = 353,25 cm²."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.cirkel-halve-vergeet-halveren", "label": "Halveren vergeten", "optionIndex": 0 },
          { "id": "met.cirkel-halve-omtrek-ipv-opp", "label": "Halve omtrek gegeven", "optionIndex": 1 },
          { "id": "met.cirkel-halve-zonder-pi", "label": "r² zonder π en halveren", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "MET-MEETK-OPP-005",
      "familyId": "MET-MEETK-OPP",
      "module": "Metriek",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_opp_cirkel",
      "questionType": "multiple_choice",
      "question": "Een tuinier legt een ronde vijver aan met een straal van 4 meter. Om de vijver komt een pad van 1 meter breed. Wat is de oppervlakte van alleen het pad? (gebruik π ≈ 3,14)",
      "context": "Een tuinier ontwerpt een vijver met een pad eromheen.",
      "options": ["78,5 m²", "28,26 m²", "50,24 m²", "5 m²"],
      "correctAnswer": 1,
      "stimulusAids": [{"type":"circle","data":{"radius":5,"label":"Vijver + pad samen"}}],
      "supportAids": [{"type":"rule","showWhen":"wrong","data":{"title":"Ring (annulus)","content":"Pad = grote cirkel − kleine cirkel. Groot (r=5): π × 25 = 78,5 m². Klein (r=4): π × 16 = 50,24 m². Pad = 78,5 − 50,24 = 28,26 m².","icon":"lightbulb"}}],
      "conceptId": "circle_area_ring",
      "variantIndex": 5,
      "citoDifficulty": 0.62,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Een ring (annulus) bereken je als verschil van twee cirkels. Grote cirkel (vijver + pad): straal = 4 + 1 = 5 m → opp = π × 25 = 78,5 m². Kleine cirkel (alleen vijver): straal = 4 m → opp = π × 16 = 50,24 m². Pad = 78,5 − 50,24 = 28,26 m². Controleer: 28,26 + 50,24 = 78,5 ✓.",
        "solutionSteps": [
          "Grote straal = 4 + 1 = 5 m",
          "Grote oppervlakte: π × 5² = 3,14 × 25 = 78,5 m²",
          "Kleine oppervlakte (vijver): π × 4² = 3,14 × 16 = 50,24 m²",
          "Pad = groot − klein = 78,5 − 50,24 = 28,26 m²",
          "Check: 28,26 + 50,24 = 78,5 ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt alleen de buitenste cirkel berekend (78,5 m²) — dat is vijver + pad samen. Trek de vijver eraf: 78,5 − 50,24 = 28,26 m². Onthoud: ring = buiten − binnen.",
          "1": "Goed! Pad = 78,5 − 50,24 = 28,26 m².",
          "2": "Je hebt alleen de binnenste cirkel berekend (50,24 m²) — dat is de vijver, niet het pad. Bereken de buitenste cirkel en trek de vijver eraf: 78,5 − 50,24 = 28,26 m².",
          "3": "Je hebt waarschijnlijk alleen het verschil van de stralen gebruikt (5² − 4² = 9, of iets dergelijks). Maar bij oppervlakte moet je twee complete oppervlaktes berekenen en dan aftrekken: 78,5 − 50,24 = 28,26 m²."
        }
      },
      "pedagogy": {
        "dok": 4,
        "misconceptionTags": [
          { "id": "met.cirkel-ring-buiten-ipv-verschil", "label": "Buitenste cirkel gegeven", "optionIndex": 0 },
          { "id": "met.cirkel-ring-binnen-ipv-verschil", "label": "Binnenste cirkel gegeven", "optionIndex": 2 },
          { "id": "met.cirkel-ring-formule-fout", "label": "Verkeerde aanpak", "optionIndex": 3 }
        ]
      }
    }
  ]
}